import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {BackOfficeInvoiceService} from '../../../../Services/invoice.service';
import {Invoice} from '../../../../Models/Invoice';
import {CreditInvoiceItem} from '../../../../Models/CreditInvoiceItem';
import {BroadcastService} from '../../../../../shared/Services/broadcast.service';

@Component({
  selector: 'app-credit-invoice',
  templateUrl: './credit-invoice.component.html',
  styleUrls: ['./credit-invoice.component.scss']
})
export class CreditInvoiceComponent implements OnInit, OnChanges {
  public orderList: any[];
  public isEdit = false;
  public creditInvoiceItems: CreditInvoiceItem[];
  @ViewChild('creditInvoiceModal', {static: false}) creditInvoiceModal;
  @ViewChild('addCreditInvoiceForm', {static: false}) addCreditInvoiceForm;
  @Input() invoiceNumber: number;
  @Input() creditInvoice;
  @Input() showModal: false;
  @Output() credited = new EventEmitter<boolean>();

  constructor(
    private invoiceService: BackOfficeInvoiceService,
    private broadcastService: BroadcastService) {
  }

  ngOnInit() {
  }

  ngOnChanges(...args: any[]) {
    this.broadcastService.on('refreshModal').subscribe(res => {
      this.creditInvoice = res;
    });
    this.creditInvoiceItems = Object.assign([], this.creditInvoice.creditInvoiceItems);
    if (this.creditInvoice.creditInvoiceItems.length === 0) {
      this.addCreditItem();
      this.isEdit = false;
    } else {
      this.isEdit = true;
    }
    this.creditInvoiceModal.show();
    this.showModal = false;
  }

  loadOrders() {
    this.invoiceService.getInvoiceOrders(this.invoiceNumber).subscribe(resp => {
      this.orderList = [];
      this.orderList = resp;
    });
  }

  addCreditItem() {
    this.creditInvoiceItems.push(new CreditInvoiceItem());
  }

  removeCreditItem(creditInvoiceItemIndex) {
    this.creditInvoiceItems.splice(creditInvoiceItemIndex, 1);
  }

  hideModal() {
    this.creditInvoiceModal.hide();
    this.showModal = false;
    this.addCreditInvoiceForm.reset();
  }

  credit() {
    const creditInvoice = new Invoice();
    creditInvoice.creditInvoiceItems = this.creditInvoiceItems;
    delete creditInvoice.creditInvoices;
    this.invoiceService.creditInvoice(creditInvoice, this.invoiceNumber, this.isEdit).subscribe(() => {
      this.creditInvoiceModal.hide();
      this.credited.emit(this.isEdit);
    });
  }
}
